import { render, staticRenderFns } from "./SendDocument.vue?vue&type=template&id=aa409cd2&scoped=true"
import script from "./SendDocument.vue?vue&type=script&lang=js"
export * from "./SendDocument.vue?vue&type=script&lang=js"
import style0 from "./SendDocument.vue?vue&type=style&index=0&id=aa409cd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa409cd2",
  null
  
)

export default component.exports